import { IntegrationType } from '@accedo/one-plugin-sdk';

import { useConfig } from '#/hooks/useConfig';
import { useFirstPluginConfig } from '#/plugins/hooks/useFirstPluginConfig';
import {
  FeatureConfig,
  FeaturePaywallProps,
} from '#/service/config/features.types';

export const usePaywallConfig = ():
  | FeatureConfig<FeaturePaywallProps>
  | undefined => {
  const config = useConfig();

  const paywall = useFirstPluginConfig(IntegrationType.PAYWALL);

  if (!config.features.purchase?.inApp?.enabled) {
    return undefined;
  }

  return paywall;
};
